import { createRouter, createWebHistory } from 'vue-router';
import Login from '../components/login_acceso.vue';
import HomeInicio from '../components/HomeInicio.vue';
import Register from '../components/registro_usuario.vue';
import subirlista from '../components/subirlista.vue'; // ✅ Importamos SubirLista.vue
import AgregarInvitado from '../components/agregarinvitados.vue'; // ✅ Importamos AgregarInvitado.vue
import confirmados from '../components/confirmados.vue'; // ✅ Importamos AgregarInvitado.vue
import miperfil from '../components/miperfil.vue'; // ✅ Importamos AgregarInvitado.vue
import invitadoCodigoQR from '../components/invitado_codigoqr.vue'; // ✅ Importamos AgregarInvitado.vue
import lectorcodigo from '../components/lector-codigo.vue'; // ✅ Importamos AgregarInvitado.vue
import albumfotos from '../components/albumfotos.vue'; // ✅ Importamos AgregarInvitado.vue
import organizador from '@/components/mesasvisualizar.vue';
import dashboard from '@/components/dashboard.vue';
const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    name: 'HomeInicio',
    component: HomeInicio,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/subirlista', // ✅ Nueva ruta para SubirLista
    name: 'subirlista',
    component: subirlista,
  },
  {
    path: '/agregar-invitado', // ✅ Nueva ruta para AgregarInvitado
    name: 'AgregarInvitado',
    component: AgregarInvitado,
  },
  {
    path: '/confirmados', // ✅ Nueva ruta para AgregarInvitado
    name: 'confirmados',
    component: confirmados,
  },

  {
    path: '/miperfil', // ✅ Nueva ruta para AgregarInvitado
    name: 'miperfil',
    component: miperfil,
  },
  {
    path: '/codigoqr/invitado/:id',
    name: "invitadoCodigoQR",
    component: invitadoCodigoQR,
    props: true, // Esto permite que el parámetro de la ruta sea pasado como una prop al componente
  },
  {
    path: '/lectorcodigo',
    name: "lectorcodigo",
    component: lectorcodigo,
    props: true, // Esto permite que el parámetro de la ruta sea pasado como una prop al componente
  },
  {
    path: '/mesas',
    name: "organizador",
    component: organizador,
    props: true, // Esto permite que el parámetro de la ruta sea pasado como una prop al componente
  },
  {
    path: '/albumfotos',
    name: "albumfotos",
    component: albumfotos,
    props: true, // Esto permite que el parámetro de la ruta sea pasado como una prop al componente
  },

    {
    path: '/dashboard',
    name: "dashboard",
    component: dashboard,
    props: true, // Esto permite que el parámetro de la ruta sea pasado como una prop al componente
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
